/* eslint-disable */

import { useState } from "react";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

import { fetchOrganisationDetailImagePost } from "../../services/api-raindrop";
import ModelComponent from "../model-component/model-component.tsx";
import RaindropInputFile from "../raindrop-input-file/raindrop-input-file.tsx";
import RaindropDivider from "../raindrop-divider/raindrop-divider.js";
import RaindropInputTextArea from "../raindrop-input-text-area/raindrop-input-text-area.tsx";

const ModelComponentOrganisationDetail = ({
  organisationDetailId,
  organisationId,
  descriptionLong,
  organisationDetailMediaObjects,
  rawData = null,
}) => {
  const [imageUrl, setImageUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [file, setFile] = useState();

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchOrganisationDetailImagePost({
      organisationId: organisationId,
      file: file,
    })
      .then((response) => {
        console.log("🟢 (RD-783) - ", response);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <ModelComponent
      modelId={organisationDetailId}
      colorBorderAccent="border-l-color-model-organisation-detail dark:border-l-color-dark-model-organisation-detail"
      rawData={rawData}
    >
      <RaindropInputTextArea
        label="Organisation Description"
        placeholder="Enter organisation description"
        value={descriptionLong}
        isEditing={false}
        icon=""
        isShowLabel={true}
      />

      <RaindropDivider />

      <div className="flex flex-col gap-2">
        <h4 className="text-left font-bold text-sm text-color-dark-text-tertiary">
          ADD MEDIA
        </h4>
        <RaindropInputFile
          label="Upload Media"
          setImageUrl={setImageUrl}
          onChange={(e) => setFile(e.target.files[0])}
        />
        <RaindropButton
          title="Save"
          icon="fa-save"
          style={ButtonStyle.Secondary}
          onClick={onSubmit}
        />
      </div>
    </ModelComponent>
  );
};

export default ModelComponentOrganisationDetail;
